import { render } from "./NeuroMedicine.vue?vue&type=template&id=1e1b8b41"
import script from "./NeuroMedicine.vue?vue&type=script&lang=ts"
export * from "./NeuroMedicine.vue?vue&type=script&lang=ts"
script.render = render

export default script